<template>
  <validation-observer ref="provider-primary-contact-info-form">
    <section-title
      class="mb-2"
      :has-line="false"
      :title="'Información de Contacto Primario'"
    />
    <contact-information
      v-model="contactInfoModel"
      :civil-statuses="civilStatuses"
      class="pl-3"
    />
  </validation-observer>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import { ContactInformation } from '@/views/provider/serviceLocation/components';

export default {
  name: 'ProviderCreateprimaryContactInformation',
  components: {
    SectionTitle,
    ContactInformation,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    valid: {
      type: Boolean,
      default: false,
    },
    proposalInfo: {
      type: Object,
      default: () => null,
    },
    civilStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    model: {
      name: '',
      department: '',
      phone: '',
      lastName: '',
      position: '',
      workPhone: '',
      motherLastName: '',
      email: '',
      fax: '',
    },
    contactInfoModel: {},
  }),
  watch: {
    proposalInfo: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal) {
            this.contactInfoModel = {
              ...this.contactInfoModel,
              nameFirst: newVal.contactName,
              nameInitial: newVal.contactNameInitial,
              nameLastPaternal: newVal.contactNameLastPaternal,
              nameLastMaternal: newVal.contactNameLastMaternal,
              email: newVal.email,
            };
          }
        }
      },
    },
  },
  methods: {
    async validate() {
      const valid = await this.$refs[
        'provider-primary-contact-info-form'
      ].validate();

      this.model = {
        initial: this.contactInfoModel.nameInitial,
        name: this.contactInfoModel.nameFirst,
        department: this.contactInfoModel.workDepartmentName,
        phone: this.contactInfoModel.telephoneMobileNo,
        lastName: this.contactInfoModel.nameLastPaternal,
        position: this.contactInfoModel.workPositionTitle,
        workPhone: this.contactInfoModel.telephoneWorkNo,
        motherLastName: this.contactInfoModel.nameLastMaternal,
        email: this.contactInfoModel.email,
        fax: this.contactInfoModel.telephoneHomeFaxNo,
        municipality: this.contactInfoModel.municipality,
        civilStatusId: this.contactInfoModel.civilStatus?.id,
      };
      const data = valid ? this.model : {};

      this.$emit('update:data');
      this.$emit('update:valid', valid);

      return { data, valid };
    },
    reset() {
      this.$refs['provider-primary-contact-info-form'].reset();
    },
  },
};
</script>
